import { z } from 'zod';
export const chargeKindSchema = z.enum([
    'Recurring',
    // A whole commitment period in one charge. Also carries a free-time window, as a zero-amount charge over the days
    // the term was extended by.
    'Upfront',
    // A period paid for by the contract a migration converted, so it carries the transferred balance and is already
    // settled. Not a free window: the money arrived, just earlier and under another contract, which is why it needs its
    // own kind rather than looking like a term we collected.
    'CreditsCoverage',
    // Only reachable on the monthly cadence.
    'EarlyCancellationFee',
    // A refund or credit note, negative, pointing at the charge it adjusts.
    'Correction',
]);
export const ChargeKind = chargeKindSchema.enum;
export const chargeStatusSchema = z.enum([
    'Draft',
    'PaymentDetailsCollected',
    'PendingPayment',
    'PaidNotActivated',
    'PartiallyPaid',
    'PaidActivated',
    'Cancelled',
    'CancelledFromOpsTool',
    'Uncollectible',
]);
export const ChargeStatus = chargeStatusSchema.enum;
export const billingProviderSchema = z.enum(['Stripe', 'Bexio']);
export const BillingProvider = billingProviderSchema.enum;
const TERMINAL_CHARGE_STATUSES = [
    ChargeStatus.PaidActivated,
    ChargeStatus.Cancelled,
    ChargeStatus.CancelledFromOpsTool,
    ChargeStatus.Uncollectible,
];
export const isTerminalChargeStatus = (status) => TERMINAL_CHARGE_STATUSES.includes(status);
export const isChargeIssued = (status) => status !== ChargeStatus.Draft;
export const isFreeTimeCharge = (charge) => charge.kind !== ChargeKind.Correction && Number(charge.totalAmount) === 0;
